import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isSessionSwitchInProgress } from '../common/sessionSwitchUtils';
import FullScreenLoader from '../common/FullScreenLoader';

export default function(ComposedComponent) {
	class MustBeAdmin extends Component {
		state = {
			isSwitching: isSessionSwitchInProgress()
		};
		componentWillMount() {
			if (!this.props.isAdmin && !this.props.isAuthenticated) {
				this.props.history.push("/login");
			} else if (!this.props.isAdmin && this.props.isAuthenticated) {
				this.props.history.push("/");
			}
		}
		componentWillUpdate(nextProps) {
			// Vérifier si le changement de session est terminé
			const wasSwitching = this.state.isSwitching;
			const isSwitching = isSessionSwitchInProgress();
			if (wasSwitching && !isSwitching) {
				this.setState({ isSwitching: false });
			} else if (!wasSwitching && isSwitching) {
				this.setState({ isSwitching: true });
			}

			if (!nextProps.isAdmin && !nextProps.isAuthenticated) {
				this.props.history.push("/login");
			} else if (!nextProps.isAdmin && nextProps.isAuthenticated) {
				this.props.history.push("/");
			}
		}
		render() {
			// Ne pas rendre le composant pendant le changement de session
			if (this.state.isSwitching) {
				return <FullScreenLoader open={true} message="Changement de compte en cours..." />;
			}
			return <ComposedComponent {...this.props} />;
		}
	}

	MustBeAdmin.propTypes = {
		isAdmin: PropTypes.bool.isRequired,
		isAuthenticated: PropTypes.bool.isRequired
	};

	function mapStateToProps(state) {
		return {
			isAdmin: state.auth.isAdmin,
			isAuthenticated: state.auth.isAuthenticated
		};
	}
	return connect(mapStateToProps)(withRouter(MustBeAdmin));
}
